import { useEffect, useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { acpSettingsGet } from "@/lib/api";
import { StatusPill } from "@/components/acp/acpUi";

// Admin → Integrations: connection status only. API keys live in the server environment and are never sent to the browser.
export default function IntegrationsSection({ recId }) {
  const [s, setS] = useState(null);
  useEffect(() => { acpSettingsGet(recId).then(setS).catch(() => setS({ error: true })); }, [recId]);
  if (!s) return <div className="py-4 flex justify-center"><Loader2 className="animate-spin text-zinc-400" size={16} /></div>;
  if (s.error) return <div className="text-xs text-zinc-500">Couldn't load integration status.</div>;
  const ig = s.integrations;
  const rows = [
    { key: "openai", name: "OpenAI / ACP", sub: "Request signing secret · order webhook", status: ig.openai.commerce_api_key && ig.openai.commerce_base_url ? "connected" : ig.openai.request_secret ? "pending" : "not_connected",
      items: [["OPENAI_COMMERCE_API_KEY", ig.openai.commerce_api_key], ["OPENAI_COMMERCE_BASE_URL", ig.openai.commerce_base_url], ["ACP_REQUEST_SECRET", ig.openai.request_secret], ["OPENAI_ORDER_WEBHOOK_URL", ig.openai.webhook_url], ["OPENAI_WEBHOOK_SECRET", ig.openai.webhook_secret]] },
    { key: "stripe", name: "Stripe", sub: "Card payments · ChatGPT shared payment tokens", status: ig.stripe.mode === "live" ? "connected" : ig.stripe.mode === "test" ? "test_mode" : "not_connected",
      items: [["STRIPE_API_KEY", ig.stripe.configured]] },
    { key: "shipstation", name: "ShipStation", sub: "Labels, UPS/USPS tracking sync", status: ig.shipstation.configured ? "connected" : "not_connected",
      items: [["SHIPSTATION_API_KEY / SECRET", ig.shipstation.configured]] },
  ];
  return (
    <div className="space-y-2" data-testid="integrations-section">
      {rows.map((r) => (
        <div key={r.key} className="rounded-xl border border-zinc-200 p-3" data-testid={`integration-${r.key}`}>
          <div className="flex items-center justify-between">
            <div><div className="text-sm font-medium text-zinc-900">{r.name}</div><div className="text-xs text-zinc-500">{r.sub}</div></div>
            <StatusPill status={r.status} testId={`integration-status-${r.key}`} />
          </div>
          <ul className="mt-2 space-y-1">
            {r.items.map(([k, ok]) => (
              <li key={k} className="flex items-center justify-between text-[11px] font-mono text-zinc-600">
                <span className="inline-flex items-center gap-1"><Lock size={10} className="text-zinc-400" /> {k}</span>
                <span className={ok ? "text-emerald-600" : "text-zinc-400"}>{ok ? "set on server" : "not set"}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <p className="text-[11px] text-zinc-400">Keys are configured in the server environment by your developer; this screen only reports whether each one is present.</p>
    </div>
  );
}
